<ion-grid class="confirmation-body">
  <div *ngIf="popupName == 'No. of Days Skipped'">
    <ion-row>
      <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7">
        <div class="fs-18 fs_16ForMobile font_bold cl-black">{{popupName}}&nbsp;({{totalCount}})</div>
      </ion-col>
      <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="text-right">
        <div class="center-content justify-content-flex-end">
          <img (click)="exportDashboardListExcel()" src="././assets/icon/download_Square.svg" class="mr-15 cp">
          <div class="close_bg display-center cp" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="skipedData?.length != 0">
      <ion-col size="12">
        <div class="table-container mt-15">
          <table class="hover mb-15">
            <thead>
              <th>
                <div class="font_semibold fs-14 fs_12ForMobile text_start">Date</div>
              </th>
              <th>
                <div class="font_semibold fs-14 fs_12ForMobile text_start">Manager Comments</div>
              </th>
            </thead>
            <tbody>
              <tr *ngFor="let item of skipedData">
                <td *ngIf="item?.skipDate!=null" class="text_start fs-14 fs_12ForMobile font_regular">{{item?.skipDate | date:'dd-MM-yyyy'}}</td>
                <td *ngIf="item?.skipDate!=null" class="text_start fs-14 fs_12ForMobile font_regular">{{item?.skipManagerComment}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="popupName == 'Days of DWM Reviewed'">
    <ion-row>
      <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7">
        <div class="fs-18 fs_16ForMobile font_bold cl-black">{{popupName}}&nbsp;({{totalCount}})</div>
      </ion-col>
      <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="text-right">
        <div class="center-content justify-content-flex-end">
          <!-- <img (click)="exportDashboardListExcel()" src="././assets/icon/download_Square.svg" class="mr-15 cp"> -->
          <div class="close_bg display-center cp" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="table-container mt-15">
        <div *ngFor="let data of calendarData">
          <label class="month_lable">{{ data.month }} {{ data.year }}</label>
          <table class="hover mb-15">
            <thead>
              <th class="font_semibold fs_14" *ngFor="let day of ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']">{{ day }}</th>
            </thead>
            <tbody>
              <tr *ngFor="let week of getWeeks(data.days,data.startDay)">
                <td *ngFor="let day of week" class="text_end tableDataSize fs-12"
                [ngClass]="{'opacity5' : !day?.highlighted}">
                  <div *ngIf="day" [ngClass]="{'font_bold' : day?.highlighted}">{{day ? day.date.getDate() : ''}}</div>
                  <div *ngIf="day?.comment" [ngClass]="{'cmtbg' : day?.comment=='Reviewed by employee',
                  'skipDaybg' : day?.comment=='The Day is Skipped'}"class="mt-10">{{ day?.comment }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="popupName == 'DWM to be reviewed'">
    <ion-row>
      <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7">
        <div class="fs-18 fs_16ForMobile font_bold cl-black">{{popupName}}&nbsp;({{totalCount}})</div>
      </ion-col>
      <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="text-right">
        <div class="center-content justify-content-flex-end">
          <img (click)="exportDashboardListExcel()" src="././assets/icon/download_Square.svg" class="mr-15 cp">
          <div class="close_bg display-center cp" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-grid>
